var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M472 112C494.094 112 512 94.094 512 72S494.094 32 472 32H392C379.312 32 367.375 38.031 359.844 48.219L99.812 400H40C17.906 400 0 417.906 0 440S17.906 480 40 480H120C132.688 480 144.625 473.969 152.156 463.781L412.188 112H472ZM472 400H360C337.908 400 320 417.908 320 440S337.908 480 360 480H472C494.092 480 512 462.092 512 440S494.092 400 472 400Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlt);
export default __webpack_public_path__ + "static/media/alt.128564b315b9a9eea6337d3ad31987ba.svg";
export { ForwardRef as ReactComponent };